import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IAPIResponse } from "../../interfaces/IAPIResponse";

export interface Tutor {
    id: number;
    email: string;
    username: string;
}

export interface Student {
    id: number;
    username: string;
    email: string;
    year_group: string;
}

export interface QuestionType {
    id: number;
    name: string;
    description: string;
    subject_id: number;
    image_url: string;
    status: boolean;
}

export interface ScheduleSetupData {
    tutors: Tutor[];
    students: Student[];
    question_types: QuestionType[];
}

export interface ScheduleSetupPayload {
    subject_id: number;
    start_time: string;
    end_time: string;
}

const initialState: IReduxState<ScheduleSetupData> = {
    data: {
        status: false,
        message: "",
        data: {
            tutors: [],
            students: [],
            question_types: []
        }
    },
    isLoading: false,
    error: null
} as IReduxState<ScheduleSetupData>;

export const ScheduleSetupDataSlice = createSlice({
    name: "ScheduleSetupDataSlice",
    initialState,
    reducers: {
        getScheduleSetupData: (state, _action: PayloadAction<ScheduleSetupPayload>) => {
            state.isLoading = true;
            state.error = null;
        },
        successGetScheduleSetupData: (state, action: PayloadAction<IAPIResponse<ScheduleSetupData>>) => {
            state.isLoading = false;
            state.data = action.payload;
        },
        failureGetScheduleSetupData: (state, action: PayloadAction<any>) => {
            state.isLoading = false;
            state.error = action.payload;
        },
    },
});

export const {
    getScheduleSetupData,
    successGetScheduleSetupData,
    failureGetScheduleSetupData,
} = ScheduleSetupDataSlice.actions;

export default ScheduleSetupDataSlice.reducer;
